import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

function RequiresCourseId({ children }) {
  const courseId = useSelector((state) => state.course.courseId);
  return courseId ? children : <Navigate to="/" replace />;
}

export default RequiresCourseId;
